import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as PapaParse from 'papaparse';
import { saveAs } from 'file-saver';

class CsvService {
    parseCsv(file, separator = ';') {
        const subject = new Subject();
        PapaParse.parse(file, {
            dynamicTyping: true,
            complete: parsingComplete,
            skipEmptyLines: true,
            delimiter: separator,
        });
        return subject;
        function parsingComplete(parseResult) {
            if (Array.isArray(parseResult.errors) && parseResult.errors.length > 0) {
                subject.error(parseResult.errors);
            }
            else {
                try {
                    const objects = convertToObjects(parseResult.data);
                    subject.next(objects);
                    subject.complete();
                }
                catch (error) {
                    subject.error(error);
                }
            }
        }
        function convertToObjects(data) {
            const headers = data && data.length > 0 ? data[0] : [];
            if (headers.length === 0) {
                throw new Error(`No data in CSV file !`);
            }
            return {
                headers,
                data: data.slice(1),
            };
        }
    }
    async parseCsvPromise(file, config = {
        dynamicTyping: false,
        skipEmptyLines: true,
        delimiter: ';',
    }) {
        return await new Promise((complete, error) => {
            PapaParse.parse(file, { ...config, complete, error });
        });
    }
    exportCsv(data, filename, delimiter = ';') {
        let csvContent = '';
        data.forEach(infoArray => {
            const dataString = infoArray.join(delimiter);
            csvContent += dataString + '\n';
        });
        this.exportCsvStringData(csvContent, filename);
    }
    exportCsvStringData(csvContent, filename) {
        const blob = new Blob([csvContent], {
            type: 'data:text/csv;charset=utf-8',
        });
        saveAs(blob, filename);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: CsvService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: CsvService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: CsvService, decorators: [{
            type: Injectable
        }] });

/*
 * Public API Surface of ssd-csv-lib-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CsvService };
